<template>
  <router-view />
</template>

<script>
export default {
  name: "Angsuran",
};
</script>
